import makeStyles from '@mui/styles/makeStyles';
import { styled } from "@mui/material/styles";

import { Button } from "../../../components/Form";

export const GenerateCSVButton = styled(Button)(() => ({
  width: 135,
}));

const styles = makeStyles(() => ({
  content: {
    padding: "15px 32px",
  },
  button: {
    cursor: "pointer",
  },
  disabledButton: {
    cursor: "default",
  },
  delayedDays: {
    font: "normal 400 12px/16px Manrope",
  },
  lowDelayed: {
    color: "#667085",
  },
  mediumDelayed: {
    color: "#DC6803",
  },
  highDelayed: {
    color: "#F04438",
  },
}));

export default styles;
